module.exports = __webpack_public_path__ + "img/yanhua.1aa02c8a.png";